import { render, staticRenderFns } from "./Measurement.vue?vue&type=template&id=c2372a5c&scoped=true"
import script from "./Measurement.vue?vue&type=script&lang=js"
export * from "./Measurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2372a5c",
  null
  
)

export default component.exports